// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"upload_dashboardContainer__l9WA2","MuiGrid-item":"upload_MuiGrid-item__0Ao2y","MuiPaper-root":"upload_MuiPaper-root__h+MaL"};